import { render, staticRenderFns } from "./EndorsementDetailsContent.vue?vue&type=template&id=57f888e2&scoped=true"
import script from "./EndorsementDetailsContent.vue?vue&type=script&lang=ts"
export * from "./EndorsementDetailsContent.vue?vue&type=script&lang=ts"
import style0 from "./EndorsementDetailsContent.vue?vue&type=style&index=0&id=57f888e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f888e2",
  null
  
)

export default component.exports